import * as type from '../actions/types';

const initialState = {
  data: {},
  fetching: true,
  submitting: false, // Submitting an update
  error: false,
  errorMessage: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_AUDIENCE_TARGETING_PENDING: {
      return {
        ...state,
        fetching: true,
        error: false,
        errorMessage: '',
      };
    }

    case type.FETCH_AUDIENCE_TARGETING_SUCCESS: {
      const rawData = action.payload.data;
      const boosts = Array.isArray(rawData) ? rawData : rawData ? [rawData] : [];
      const attractNewBoost = boosts.find((b) => b.newUsersOnly === true);
      const winBackBoost = boosts.find((b) => b.newUsersOnly === false);

      return {
        ...state,
        data: { boosts, attractNewBoost, winBackBoost },
        fetching: false,
        error: false,
        errorMessage: '',
      };
    }
    case type.FETCH_AUDIENCE_TARGETING_FAILURE: {
      return {
        ...state,
        fetching: false,
        error: true,
        errorMessage: action.payload,
      };
    }

    case type.UPDATE_AUDIENCE_TARGETING_PENDING: {
      return {
        ...state,
        submitting: true,
        error: false,
        errorMessage: '',
      };
    }

    case type.UPDATE_AUDIENCE_TARGETING_SUCCESS: {
      return {
        ...state,
        submitting: false,
      };
    }
    case type.UPDATE_AUDIENCE_TARGETING_FAILURE: {
      return {
        ...state,
        submitting: false,
        error: true,
        errorMessage: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};
